import axios from "axios";

type IndividualForm = {
  name: string;
  email: string;
  organization: string;
  phone: string;
};

type OrgranizationForm = {
  name: string;
  email: string;
  phone: string;
  bik: string;
  bin: string;
  ibankName: string;
  iban: string;
  ibankEmail: string;
};

export const sendIndividualForm = (form: IndividualForm) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(form));
  // Object.entries(form).forEach(([key, value]) => formData.append(key, value));
  return axios.post("https://optimmanagement.kz/api/?action=setBadgeData", formData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

export const sendOrganizationForm = (form: OrgranizationForm) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(form));
  // Object.entries(form).forEach(([key, value]) => formData.append(key, value));
  return axios.post("https://optimmanagement.kz/api/?action=setDataUr", formData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
